import React, { useState, useEffect } from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Box,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import {
  Menu as MenuIcon,
  Dashboard,
  Assessment,
  Build,
  CompareArrows,
  Work,
  SupervisorAccount,
  Description,
  ChevronLeft,
  TroubleshootOutlined,
  LockOutlined,
  Chat,
  Support as SupportIcon,
} from "@mui/icons-material";
import { useNavigate, useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";
import axios from "axios";

const NavigationSidebar = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [open, setOpen] = useState(!isMobile);
  const navigate = useNavigate();
  const location = useLocation();
  const { userId } = useParams();
  const [hasUpgraded, setHasUpgraded] = useState(false);

  useEffect(() => {
    const checkUpgradeStatus = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/user/${userId}/upgrade-status`
        );
        setHasUpgraded(response.data.hasUpgraded);
      } catch (error) {
        console.error("Error checking upgrade status:", error);
      }
    };

    if (userId) {
      checkUpgradeStatus();
    }
  }, [userId, location.pathname]);

  const menuItems = [
    {
      text: "Dashboard",
      icon: <Dashboard />,
      path: `/dashboard/${userId}`,
      alwaysShow: true,
    },
    {
      text: "Career Analysis",
      icon: <Assessment />,
      path: `/report/${userId}`,
      alwaysShow: true,
    },

    {
      text: "Career Report",
      icon: <TroubleshootOutlined />,
      path: `/report/${userId}?showSummary=true`,
      alwaysShow: false,
    },
    // {
    //   text: "Ask Caroline",
    //   icon: <Chat />,
    //   path: `/ai-chat/${userId}`,
    //   alwaysShow: true,
    // },
    // {
    //   text: "Handling Retrenchment",
    //   icon: <SupervisorAccount />,
    //   path: `/careertransitions/${userId}`,
    //   alwaysShow: true,
    // },
    // {
    //   text: "Company Resources",
    //   icon: <Build />,
    //   path: `/cheat-sheets/${userId}`,
    //   alwaysShow: false,
    // },
    // {
    //   text: "Mid Career Switch",
    //   icon: <CompareArrows />,
    //   path: `/mid-career-switching/${userId}`,
    //   alwaysShow: false,
    // },
    // {
    //   text: "Land Dream Job",
    //   icon: <Work />,
    //   path: `/land-your-dream-job/${userId}`,
    //   alwaysShow: false,
    // },
    // {
    //   text: "Special Coaching",
    //   icon: <SupervisorAccount />,
    //   path: `/special-coaching/${userId}`,
    //   alwaysShow: false,
    // },
    // {
    //   text: "Resume Samples",
    //   icon: <Description />,
    //   path: `/resume-templates/${userId}`,
    //   alwaysShow: false,
    // },

    {
      text: "Support",
      icon: <SupportIcon />,
      path: `/support/${userId}`,
      alwaysShow: true,
    },
  ];

  const drawerWidth = open ? "240px" : "60px";

  const handleItemClick = (item) => {
    // If we're already on the report page but with different parameters,
    // force a navigation refresh
    if (location.pathname === item.path.split("?")[0]) {
      window.location.href = item.path;
    } else {
      navigate(item.path);
    }
    if (isMobile) setOpen(false);
  };

  const isPathSelected = (itemPath) => {
    const [itemBasePath, itemSearch] = itemPath.split("?");
    const [currentBasePath, currentSearch] = (
      location.pathname + location.search
    ).split("?");

    // For Career Analysis (no search params)
    if (!itemSearch) {
      return currentBasePath === itemBasePath && !currentSearch;
    }

    // For Career Report (with search params)
    return currentBasePath === itemBasePath && currentSearch === itemSearch;
  };

  return (
    <>
      {/* Mobile Menu Button - Always visible on mobile */}
      {isMobile && !open && (
        <IconButton
          onClick={() => setOpen(true)}
          sx={{
            position: "fixed",
            left: 16,
            top: 16,
            zIndex: theme.zIndex.drawer + 2,
            bgcolor: "background.paper",
            boxShadow: 1,
            "&:hover": { bgcolor: "action.hover" },
          }}
        >
          <MenuIcon />
        </IconButton>
      )}

      <Drawer
        variant={isMobile ? "temporary" : "permanent"}
        open={isMobile ? open : true}
        onClose={() => setOpen(false)}
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
            transition: theme.transitions.create(["width", "transform"], {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.enteringScreen,
            }),
            visibility: "visible",
            display: "block",
            zIndex: theme.zIndex.drawer,
            height: "100%",
            position: "fixed",
          },
        }}
      >
        <Box
          sx={{
            mt: 2,
            display: "flex",
            justifyContent: "flex-end",
            pr: 1,
          }}
        >
          <IconButton
            onClick={() => setOpen(!open)}
            sx={{
              "&:hover": { bgcolor: "action.hover" },
            }}
          >
            {open ? <ChevronLeft /> : <MenuIcon />}
          </IconButton>
        </Box>

        <List>
          {menuItems.map((item) => (
            <ListItem
              button
              key={item.text}
              onClick={() => handleItemClick(item)}
              selected={isPathSelected(item.path)}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              {open && <ListItemText primary={item.text} />}
            </ListItem>
          ))}
        </List>
      </Drawer>
    </>
  );
};

export default NavigationSidebar;
